"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAssociatedTierError = void 0;
// eslint-disable-next-line max-classes-per-file
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const subscription_1 = require("@powerednow/shared/constants/subscription");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
class NoAssociatedTierError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NoAssociatedTierError';
    }
}
exports.NoAssociatedTierError = NoAssociatedTierError;
// eslint-disable-next-line no-redeclare, max-classes-per-file
class PurchaseSetup extends complexData_1.default {
    static get allowedAssociations() {
        return {
            productTierToSubscription: {
                key: 'productTierToSubscription',
                instance: (0, modelLookup_1.complexFindModel)('ProductTierToSubscription'),
                condition: {
                    purchase_setup_id: this.Entity.getFieldSymbols().id,
                },
            },
        };
    }
    /**
     * In case of Grahams productTierToSubForWhitelabelId will be undefined since there are
     * no mappings added in the ProductTierToSubscription table.  We have let this one go,
     * as Grahams is no longer an active white-label project. However, if a new white-label
     * project comes up, mappings have to be added to the ProductTierToSubscription table;
     * otherwise, the registration process will fail with a 'No productTierToSubscription
     * for purchaseSetup' error message.
     * @param productTierToSubscriptions
     * @param whiteLabelId
     */
    static findProductTierToSubForWhitelabelId(productTierToSubscriptions, whiteLabelId) {
        return productTierToSubscriptions.find(productTierToSubscription => {
            const validatedWhiteLabelId = (0, modelLookup_1.complexFindModel)('WhiteLabel').validateWhiteLabelId(whiteLabelId);
            return productTierToSubscription.data.whitelabel_id === validatedWhiteLabelId;
        });
    }
    async getTier(whiteLabelId = subscription_1.WHITE_LABEL_IDS.POWEREDNOW) {
        const productTierToSubscriptions = await this.getAllProductTierToSubscription();
        const productTierToSubForWhitelabelId = PurchaseSetup.findProductTierToSubForWhitelabelId(productTierToSubscriptions, whiteLabelId);
        if (!productTierToSubForWhitelabelId) {
            throw new NoAssociatedTierError(`No productTierToSubscription for purchaseSetup: ${this.data.id}`);
        }
        return productTierToSubForWhitelabelId.getProductTier();
    }
    isSupportMultiUserMode() {
        return Boolean(this.data.users > 1 || this.data.team_enabled);
    }
}
PurchaseSetup.Entity = entity_1.default;
PurchaseSetup.modelProperties = modelProperties_1.default;
exports.default = PurchaseSetup;
//# sourceMappingURL=../../../../src/models/purchaseSetup/index.js.map